// extracted by mini-css-extract-plugin
export default {"input":"FormRoomOrder_input__GZipA"};